<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import ChatWithSupportLink from "@shared/svelte/Components/ChatWithSupportLink.svelte";
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import type { CartProduct } from "@shared/types/ProductLine";
  import type { Distributor } from "@shared/types/Distributor";
  import * as _ from "lodash";
  export let Cart: any;
  export let productLine: any;
  export let product: CartProduct;
  export let saveCB: any;
  let showDistributorChoiceModal = true;

  let loaded = false;
  let distributors: Distributor[] = [];
  let selectedDistributor: Distributor;

  function findSelected() {
    var selected = _.get(productLine, "distributor.id");
    if (selected) {
      selectedDistributor = _.find(distributors, function (x: any) {
        return x.id == selected;
      });
    }
  }

  function load() {
    Cart.RProductLine.distributors(productLine, product).then(
      function success(res: any) {
        distributors = res.data;
        findSelected();
        loaded = true;
      },
      function error() {
        Cart.Flash.setMessage("Sorry, we've had a problem. Please contact support", false, "alert");
        close();
      }
    );
  }

  load();

  function close() {
    showDistributorChoiceModal = false;
  }

  function select(distributor: Distributor) {
    selectedDistributor = distributor;
  }

  function save() {
    Cart.RProductLine.selectDistributor(productLine, product, selectedDistributor).then(
      function success(res: any) {
        Cart.Flash.setMessage(
          "Thanks! You can now order from " + selectedDistributor.name + " for this product.",
          true,
          "notice"
        );
        saveCB(selectedDistributor, res.data);
        close();
        window["stateService"].reload();
      },
      function error() {
        Cart.Flash.setMessage("Sorry, we've had a problem. Please contact support", true, "alert");
        close();
      }
    );
  }

  const successEmail = _.get(window, "$rootScope.C.SUCCESS_EMAIL") || "support@provi.com";

</script>

<Modal bind:show={showDistributorChoiceModal}>
  <div
    class="background-white problematic-choice-modal problematic-choice-modal__slide align-center"
  >
    <div class="problematic-choice-modal__header full-width">
      <div class="media-fixed align-right" on:click={close} data-testid="close-button">
        <Icon type={"X"} height="16" width="16" extraClassNames="cursor-pointer close-modal" />
      </div>
      {#if productLine.product_type_name === "Non-Alcoholic" || productLine.product_type_name === "Non-Beverage" || (productLine.distributor || {}).always_choose_distributor}
        <div class="default-title--regular margin-top--smaller margin-bottom--small notranslate">
          Which distributor would you like to order {productLine.name} from?
        </div>
      {/if}
      {#if !(productLine.product_type_name === "Non-Alcoholic" || productLine.product_type_name === "Non-Beverage" || (productLine.distributor || {}).always_choose_distributor)}
        <div class="default-title--regular margin-top--smaller margin-bottom--small notranslate">
          Who is your {productLine.name} distributor?
        </div>
      {/if}
      <hr class="hr hr-card-separator--header" />
    </div>
    <div class="problematic-choice-modal_distributor-container full-width">
      {#if loaded && distributors.length > 0}
        <ul
          class="problematic-choice-modal_distributor-list list list--vertical list--gutter-smallest list--align-middle full-width"
        >
          {#each distributors as distributor}
            <li class="list-item">
              <div
                class="problematic-choice-modal_distributor-select ellipsis"
                id="choose_distributor_{distributor.id}"
                on:click={() => select(distributor)}
              >
                <div
                  class="problematic-choice-modal_distributor-select-label default-small--bold capitalize"
                />
                <!-- svelte-ignore a11y-label-has-associated-control -->
                <label
                  class="problematic-choice-modal_distributor-select-button button button--state {(
                    selectedDistributor || {}
                  ).id == distributor.id
                    ? 'active'
                    : ''}"
                >
                  {distributor.name}
                </label>
              </div>
            </li>
          {/each}
        </ul>
      {/if}
      <div class="margin-top--medium margin-bottom--medium">
        {#if loaded && distributors.length == 0}
          <div>
            No distributors are available for this product. Please contact <a
              class="color-brandPrimary cursor-pointer"
              href="mailto:{successEmail}">support</a
            > for more information!
          </div>
        {/if}
        {#if !loaded}
          Loading
        {/if}
      </div>
    </div>
    <div class="problematic-choice-modal__bottom-actions full-width">
      <hr class="hr hr-card-separator--header" />
      <div class="default-body--regular margin-top--medium notranslate">
        Don't see your distributor for {productLine.name}?<br />
        <ChatWithSupportLink
          message={"contact our support team"}
          brandprimary={true}
          onClick={close}
        />
      </div>

      <button
        class="button button--primary margin-top--small margin-bottom--medium"
        on:click={save}
        disabled={!selectedDistributor}
      >
        Save and Continue
      </button>
    </div>
  </div>
</Modal>
